import CreativeTable from './creative-table';

export default CreativeTable;
